import { __ } from "@wordpress/i18n";
import * as Yup from "yup";
import {
    QUOTE_PAYMENT_OPTIONS,
    QUOTE_PAYMENT_PROPERTY_VALUE_MIN,
    QUOTE_PAYMENT_PROPERTY_VALUE_MAX,
    QUOTE_PAYMENT_LOAN_TERM_MIN,
    QUOTE_PAYMENT_LOAN_TERM_MAX,
} from "./FormConfig";
import { validationsLocale } from "./ValidationsLocale";

/**
 * Configure the Yup validation locale for standardized validation messages.
 */
Yup.setLocale(validationsLocale);

/**
 * Centralized validation messages used across the `quote_payment` form.
 */
const MESSAGES = {
    required: __("Este campo é de preenchimento obrigatório.", "df-simulators"),
    oneOf: __("O valor selecionado é inválido.", "df-simulators"),
    downPaymentExceedsPrice: __(
        "Os capitais próprios não podem ser iguais ou superiores ao preço do imóvel.",
        "df-simulators"
    ),
};

/**
 * Validation schema for the `quote_payment` form.
 *
 * Mirrors the constraints of the external `/api/mac/quote/payment` endpoint
 * (country fixed to "ES", loan term 1-40 years, rateType FIXED/VARIABLE only).
 */
export const validations: Record<string, Yup.ObjectSchema<any>> = {
    quote_payment: Yup.object().shape({
        propertyValue: Yup.number()
            .typeError(MESSAGES.required)
            .min(QUOTE_PAYMENT_PROPERTY_VALUE_MIN)
            .max(QUOTE_PAYMENT_PROPERTY_VALUE_MAX)
            .required(MESSAGES.required),
        downPaymentAmount: Yup.number()
            .typeError(MESSAGES.required)
            .positive()
            .required(MESSAGES.required)
            .test(
                "less-than-property-value",
                MESSAGES.downPaymentExceedsPrice,
                function (value) {
                    const { propertyValue } = this.parent;
                    if (!propertyValue || value === undefined) return true;
                    return value < propertyValue;
                }
            ),
        loanTermInYears: Yup.number()
            .typeError(MESSAGES.required)
            .integer()
            .min(QUOTE_PAYMENT_LOAN_TERM_MIN)
            .max(QUOTE_PAYMENT_LOAN_TERM_MAX)
            .required(MESSAGES.required),
        rateType: Yup.string()
            .oneOf(QUOTE_PAYMENT_OPTIONS.rateType.map((option) => option.value), MESSAGES.oneOf)
            .required(MESSAGES.required),
        region: Yup.string()
            .oneOf(QUOTE_PAYMENT_OPTIONS.region.map((option) => option.value), MESSAGES.oneOf)
            .required(MESSAGES.required),
        condition: Yup.string()
            .oneOf(QUOTE_PAYMENT_OPTIONS.condition.map((option) => option.value), MESSAGES.oneOf)
            .required(MESSAGES.required),
        country: Yup.string().oneOf(["ES"]).required(),
    }),
};
